import {
  Game,
  GameKind,
  QuickRankConfiguration,
  QuickRankMode,
  SwiperConfiguration,
  WordleConfiguration,
  WordopolisConfiguration,
} from "../../gql/graphql";
import { isQuickPickGame } from "./isQuickPickGame";

export type LeaderboardGame = Omit<Game, "configuration"> & {
  configuration:
    | SwiperConfiguration
    | WordopolisConfiguration
    | WordleConfiguration
    | (Omit<QuickRankConfiguration, "mode"> & {
        mode: QuickRankMode.AllUp;
      });
};

export function isLeaderboardGame(game?: Game | null): game is LeaderboardGame {
  return (
    game?.kind === GameKind.Swiper ||
    game?.kind === GameKind.Wordopolis ||
    game?.kind === GameKind.Trivia ||
    game?.kind === GameKind.Wordle ||
    isQuickPickGame(game)
  );
}
